import { render, staticRenderFns } from "./KidsProductEdit.vue?vue&type=template&id=678c9a8f&scoped=true"
import script from "./KidsProductEdit.vue?vue&type=script&lang=js"
export * from "./KidsProductEdit.vue?vue&type=script&lang=js"
import style0 from "./KidsProductEdit.vue?vue&type=style&index=0&id=678c9a8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678c9a8f",
  null
  
)

export default component.exports